export const report = (error: string | Error, context?: Record<string, unknown>) => {
  const Honeybadger = window?.Honeybadger

  if (!Honeybadger) return

  if (context) {
    Honeybadger.setContext(context)
  }

  Honeybadger.setContext({ tags: 'frontend' })
  Honeybadger.notify(error)
  Honeybadger.clear()
}
